import * as React from 'react';
import { DataService } from '../../../services/data_service';
import DialogWrapper2 from '../../../core/dialog/dialog_wrapper_v2';
import { FileUploadDialog } from '../../../core/fileupload/FileUploadDialog';
import { IDs } from '../../../helpers/IDs';
import { ImportErzeugungsLastdaten } from './routinen/importErzeugungsLastendaten';
import { lazyInject } from '../../../services/inversify';
import { StructureService } from '../../../services/structure_service';
import style from '../../../default.less';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';
import { WTable } from '../../../core/table/WTable';

interface PvToolErzeugungsLastdatenImportProps extends React.ClassAttributes<any> {
    data: any;
}

interface PvToolErzeugungsLastdatenImportState {
    dataImport: any;
    isImporting: boolean;
    isLoaded: boolean;
    isLoading: boolean;
    isPreview: boolean;
}

export class PvToolErzeugungsLastdatenImport extends
    React.Component<PvToolErzeugungsLastdatenImportProps, PvToolErzeugungsLastdatenImportState> {

    constructor(props: any) {
        super(props);
        this.state = {
            dataImport: {},
            isImporting: false,
            isLoaded: false,
            isLoading: false,
            isPreview: false
        };
        this.onCancel = this.onCancel.bind(this);
        this.onDataImported = this.onDataImported.bind(this);
        this.onDataImporting = this.onDataImporting.bind(this);
        this.onDataLoaded = this.onDataLoaded.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(StructureService) private structureService: StructureService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    getColumns(): any[] {
        const structure: any = this.structureService.getStructureByKey(IDs.MOD_ETOOL_ADMIN, IDs.ENT_ERZEUGUNGS_LASTDATEN);
        const columns: any[] = [(structure.ATTS || [])
            .map((item: any) => {
                return {
                    accessor: (item.KEY || ''),
                    Header: (item.NAME || ''),
                    HeaderText: (item.NAME || ''),
                    id: (item.KEY || ''),
                    ...(item.TYPE ? { FORMAT: item.TYPE } : {}),
                    ...(item.FORMAT ? { FORMAT: item.FORMAT } : {})
                };
            })];

        return columns[0] || [];
    }

    onCancel(): void {
        this.setState({ isLoaded: false, isLoading: false, dataImport: {} });
    }

    onDataImported(success: boolean): void {
        if (success) {
            alert('Die Datensätze wurden erfolgreich importiert');
            this.triggerService.fire('admin_reload', IDs.ENT_ERZEUGUNGS_LASTDATEN);
        } else {
            alert('Die Datensätze konnten nicht importiert werden');
        }
        this.setState({ isLoaded: false, isImporting: false, dataImport: {} });
    }

    onDataImporting(callback: (success: boolean) => void): void {
        const { insert, update } = this.state.dataImport;
        const data: any[] = [...insert, ...update];
        const maxRows = 100;
        const rounds: number = (data && data.length)
            ? Math.ceil((data.length / maxRows))
            : 0;
        let round = 0;

        const setData = (dataImport: any[], complete: boolean) => {
            this.dataService.saveDataList(IDs.ENT_ERZEUGUNGS_LASTDATEN, dataImport, (sql: string, success: boolean) => {
                if (complete && typeof callback === 'function') {
                    callback(success);
                }
            }, IDs.MOD_ETOOL_ADMIN);
        };
        this.setState({ isImporting: true });

        while (round < rounds) {
            const start: number = round * maxRows;
            const end: number = start + maxRows;
            const dataChunk: any[] = data.slice(start, end);
            setData(dataChunk, !(rounds - round - 1));
            ++round;
        }
    }

    onDataLoaded(dataLoaded: string): void {
        const Import = new ImportErzeugungsLastdaten(dataLoaded, 2, ((this.props.data || {})[IDs.ENT_ERZEUGUNGS_LASTDATEN] || []));

        this.setState({
            isLoaded: true,
            isLoading: false,
            dataImport: {
                ...this.state.dataImport,
                insert: Import.getDataInsert(),
                update: Import.getDataUpdate(),
                uptodate: Import.getDataUptodate()
            }
        });
    }

    render(): JSX.Element {
        return (
            <div style={{ textAlign: 'center', padding: 20 }}>
                <div className={style.infofield}>
                    Erzeugungs- und Lastdaten aus Excel importieren
                    <FileUploadDialog
                        onDataLoaded={this.onDataLoaded}
                        onDataSelected={() => this.setState({ isLoading: true })}
                    />
                </div>
                {this.state.isLoaded && this.renderErgebnis()}
                {this.state.isLoading && <WSpinner label='Laden'/>}
                {this.state.isImporting && <WSpinner label='Senden'/>}
                {this.state.isPreview && this.renderDialog()}
            </div>
        );
    }

    renderButtons(): JSX.Element {
        const { dataImport } = this.state;
        const isDisabled: boolean = (
            (!dataImport.insert && !dataImport.update)
            || (
                !(dataImport.insert || []).length
                && !(dataImport.update || []).length
            )
        );

        return (
            <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'right' }}>
                <WActionButton
                    label='Abbrechen'
                    key='cancel'
                    action='cancel'
                    onAction={this.onCancel}
                    insideText='Abbrechen'
                />
                <WActionButton
                    label='Importieren'
                    key='import'
                    action='import'
                    onAction={() => { this.onDataImporting(this.onDataImported); }}
                    insideText='Importieren'
                    disabled={isDisabled}
                />
                {/*<WActionButton
                    label='Vorschau'
                    key='preview'
                    action='view'
                    onAction={() => { this.setState({ isPreview: true }, this.renderDialog); }}
                    insideText='Vorschau'
                    disabled={isDisabled}
                />*/}
            </div>
        );
    }

    renderDialog(): JSX.Element {
        const { insert, update } = this.state.dataImport;
        const data: any[] = [...insert, ...update];

        return (
            <DialogWrapper2
                title={'Neue/geänderte Datensätze'}
                onAfterClose={() => { this.setState({ isPreview: false }); }}
            >
                <WTable
                    key='erzeugungs_lastdaten'
                    entity={IDs.ENT_ERZEUGUNGS_LASTDATEN}
                    module={IDs.MOD_ETOOL_ADMIN}
                    data={data}
                    onAction={() => {}}
                    customClass='Custom-ETA'
                    columns={this.getColumns()}
                    defaultSorted={[{ id: 'zeit', asc: true }]}
                    showPagination={true}
                    filterable={false}
                />
            </DialogWrapper2>
        );
    }

    renderErgebnis(): JSX.Element {console.info(this.state.dataImport);
        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'left', marginTop: '1em', marginBottom: '1em' }}>
                    {this.renderZusammenfassung()}
                 </div>
                {this.renderButtons()}
            </div>
        );
    }

    renderStatuszeilen(): JSX.Element[] {
        const { dataImport } = this.state;
        const zeilen: JSX.Element[] = [];

        Object.keys(dataImport).forEach((status: string, index) => {
            const anzahl: number = dataImport[status].length;
            let text: string = null;

            switch (status) {
                case 'insert':
                    if (anzahl === 1) {
                        text = 'neuen Datensatz gefunden';
                    } else {
                        text = 'neue Datensätze gefunden';
                    }
                    break;
                case 'update':
                    if (anzahl === 1) {
                        text = 'geänderteten Datensatz gefunden';
                    } else {
                        text = 'geändertete Datensätze gefunden';
                    }
                    break;
            }

            if (anzahl && text) {
                zeilen.push(<div key={`zeile_${index}`}><strong>{anzahl}</strong> {text}</div>);
            }
        });

        if (!zeilen.length) {
            zeilen.push(<div key='zeile_'>Es wurden keine Datensätze gefunden...</div>);
        }
        return zeilen;
    }

    renderZusammenfassung(): JSX.Element {
        return (
            <div style={{ width: 800 }}>
                Zusammenfassung:
                <div
                    style={{ backgroundColor: '#eee', padding: 10, fontSize: 12, overflow: 'auto' }}
                >
                    {this.renderStatuszeilen()}
                </div>
            </div>
        );
    }
}
